var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { "data-test": _vm.CypressTarget("EventInformation") } },
    [
      _vm.loading.events
        ? _c("event-information-page-skeleton", {
            attrs: { square: true, flat: true }
          })
        : _c(
            "div",
            {
              staticClass: "event-data row",
              staticStyle: { position: "relative" }
            },
            [
              _c(
                "div",
                {
                  class: _vm.isInfoEvent(_vm.singleEventInformation)
                    ? "col-xs-12 col-sm-12 col-md-12"
                    : "col-xs-12 col-sm-12 col-md-6"
                },
                [
                  _c("card-event", {
                    class: { "no-margin": _vm.$q.platform.is.mobile },
                    attrs: {
                      square: true,
                      flat: true,
                      display: _vm.cardDisplay,
                      color: _vm.SET_COLOR.primary,
                      "event-address": _vm.singleEventInformation.address,
                      "event-location-name":
                        _vm.singleEventInformation.location_name,
                      "event-description":
                        _vm.singleEventInformation.event_description,
                      "event-geo-coordinates":
                        _vm.singleEventInformation.geo_position,
                      "event-name": _vm.singleEventInformation.name,
                      "event-image": _vm.singleEventInformation.image_poster,
                      "event-short-description":
                        _vm.singleEventInformation.short_description,
                      "event-date": _vm.singleEventInformation.sales_start,
                      "event-subtitle": _vm.singleEventInformation.serie,
                      featured: _vm.singleEventInformation.featured,
                      "is-info-event": _vm.isInfoEvent(
                        _vm.singleEventInformation
                      ),
                      "event-timezone":
                        _vm.singleEventInformation.timezone_converted,
                      "show-event-indicative-classification":
                        _vm.indicativeClassification.displayOnWeb,
                      "event-indicative-classification-image":
                        _vm.indicativeClassification.imageURL,
                      "event-indicative-classification-description":
                        _vm.indicativeClassification.description,
                      inline: ""
                    }
                  })
                ],
                1
              ),
              !_vm.isInfoEvent(_vm.singleEventInformation)
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12 col-md-6" },
                    [
                      _c(
                        _vm.eventTicketStatusComponent.component,
                        _vm._b(
                          { tag: "component" },
                          "component",
                          _vm.eventTicketStatusComponent.bind,
                          false
                        )
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }